// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FutNxsZIxSuNATBrQzMb {
    flex: 1;
    display: flex;
    background-color: #eff1f3;
}

.IOUvGLWmwhkKsq8Esb8M {
    display: flex;
    max-width: 1280px;
}

.cnXvsuzzGXNRkASTunaM {
    margin-right: 32px;
    flex: 5;
}

.U0cFnfRLK8w13Xb0_zLg {
    flex: 4;
}

.V8PfOik7e3RFLZ4uQXKA {
    font-size: 14px;
}

.wbeUmxJqb1fN8mlvHYu6 {
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
}

.wbeUmxJqb1fN8mlvHYu6 a + a {
    margin-right: 8px;
}

.vYQzCL9wXGwwYiMGSmqV {
    cursor: pointer;
    font-weight: normal;
}

.vYQzCL9wXGwwYiMGSmqV > input[type="checkbox"] {
    cursor: pointer;
    font-size: 20px;
    margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/settings/pages/scheduled-updates/index.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".page {\n    flex: 1;\n    display: flex;\n    background-color: #eff1f3;\n}\n\n.content {\n    display: flex;\n    max-width: 1280px;\n}\n\n.settings {\n    margin-right: 32px;\n    flex: 5;\n}\n\n.preview {\n    flex: 4;\n}\n\n.description {\n    font-size: 14px;\n}\n\n.previewTypes {\n    align-items: center;\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n.previewTypes a + a {\n    margin-right: 8px;\n}\n\n.label {\n    cursor: pointer;\n    font-weight: normal;\n}\n\n.label > input[type=\"checkbox\"] {\n    cursor: pointer;\n    font-size: 20px;\n    margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `FutNxsZIxSuNATBrQzMb`,
	"content": `IOUvGLWmwhkKsq8Esb8M`,
	"settings": `cnXvsuzzGXNRkASTunaM`,
	"preview": `U0cFnfRLK8w13Xb0_zLg`,
	"description": `V8PfOik7e3RFLZ4uQXKA`,
	"previewTypes": `wbeUmxJqb1fN8mlvHYu6`,
	"label": `vYQzCL9wXGwwYiMGSmqV`
};
export default ___CSS_LOADER_EXPORT___;
